import ICLICommand from "flow/interfaces/ICLICommand";
import $ from "jquery";

export default {
    name: "man",
    description: "Shows the manual page for the specified command",
    options: [],
    arguments: [
        {
            name: "name",
            description: "The command we want to see the documentation for.",
            type: "string",
            mandatory: true
        }
    ],
    callback: (writer, optsAndArgs) => {
        const command: ICLICommand = optsAndArgs._commandRepository.getCommand(optsAndArgs.name);

        if (!command) {
            if (optsAndArgs.name) {
                writer.help.writeLine("No manual entry for " + optsAndArgs.name);
                return { input: "" };
            } else {
                writer.help.writeLine("What manual page do you want?");
                return { input: "" };
            }
        }

        const args = command.arguments.map(a => a.name).join(" ");
        writer.output.writeLine(
            "Usage: " +
                optsAndArgs.name +
                (command.options.length > 0 ? " [options] " : " ") +
                (command.arguments.length > 0 ? args : "")
        );

        if (command.options.length > 0) {
            writer.output.writeLine("");
            writer.output.writeLine("Options:");
            $.each(command.options, function () {
                writer.output.writeLine("-" + this.shortName + ", --" + this.name + " - " + this.description);
            });
        }

        if (command.arguments.length > 0) {
            writer.output.writeLine("");
            writer.output.writeLine("Arguments:");
            $.each(command.arguments, function () {
                writer.output.writeLine(this.name + " - " + this.description);
            });
        }

        return { input: "" };
    }
} as ICLICommand;
